import React, { useContext } from "react";
import Hero from "./Hero";
import FeaturedSection from "./FeaturedSection";
import PostCard from "./PostCard";
import ParallaxSection from "./ParallaxSection";
import KanziSlideshow from "./KanziSlideshow";
import VideoHeader from "./VideoHeader";
import "./FeaturedSection.css";
import "./Home.css"; // Import the Home.css file
import KanziMemorial from "./KanziMemorial";

const Home = () => {
  return (
    <div>
      <VideoHeader />
      <KanziMemorial />
      <KanziSlideshow />
      <Hero />
      <ParallaxSection />
      <FeaturedSection />
    </div>
  );
};

export default Home;
